// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_2vh","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_Tu- StatelessWorkCardsUpsellModal-styles-cls1_2vh"};